import { useEffect, useState } from "react";

const INITIAL_GRID_STATE = {
  gridData: []
};

const useLSCRoleEmailGrid = (data) => {
  const [gridState, setGridState] = useState(INITIAL_GRID_STATE);

  useEffect(() => {
    if (Array.isArray(data)) {
      setGridState({
        ...gridState,
        gridData: data
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps   
  }, [data]);

  return {
    gridState
  };
};

export default useLSCRoleEmailGrid;